<mat-toolbar class="header">
  <div class="logo-menu">
    <button (click)="clickEmitter.emit()" mat-button>
      <mat-icon>menu</mat-icon>
    </button>
    <app-logo></app-logo>
  </div>

  <div class="r-side">
    @if (selectedProject$ | async; as selectedProject) {
      <mat-form-field class="project-field" subscriptSizing="dynamic">
        @if (!selectedProject.name) {
          <mat-label>{{ 'MENU.no_project' | translate }}</mat-label>
        }
        @if (selectedProject.isoCode) {
          <app-flag-icon
            [code]="selectedProject.isoCode"
            class="flag"
            matPrefix>
          </app-flag-icon>
        }
        <mat-select (valueChange)="navigateToProject($event)"
          (opened)="focus(search)"
          [value]="selectedProject.route"
          [panelClass]="['project-select', 'select']">
          <div class="sticky">
            <app-select-search #search></app-select-search>
          </div>
          @for (project of projects$ | async; track project) {
            <mat-option
              (mouseup)="navigateFromMouse($event, project)"
              [value]="project.route">
              <app-project-view [iso]="project.isoCode || ''" [name]="project.name"></app-project-view>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <button [matMenuTriggerFor]="projectsMenu" [title]="username$ | async" class="profile-trigger" mat-button>
      <span class="profile-content">
        <span class="profile-name">{{ username$ | async }}</span>
        <img alt="" src="assets/img/user.png" class="user-img">
      </span>
    </button>
  </div>
</mat-toolbar>

<mat-menu #projectsMenu="matMenu" [overlapTrigger]="false" xPosition="before">
  <ng-template matMenuContent>
    <a routerLink="/project" mat-menu-item>
      <mat-icon color="primary" mat-list-icon>home</mat-icon>
      <mat-label>{{ 'MENU.dashboard' | translate }}</mat-label>
    </a>
    <a routerLink="/account" mat-menu-item>
      <mat-icon color="primary" mat-list-icon>account_box</mat-icon>
      <mat-label>{{ 'MENU.account' | translate }}</mat-label>
    </a>
    <a routerLink="/root/managers" *isRoot mat-menu-item>
      <mat-icon color="primary" mat-list-icon>supervisor_account</mat-icon>
      <mat-label>{{ 'MENU.admin_panel' | translate }}</mat-label>
    </a>
    <a routerLink="/dev" *isDev mat-menu-item>
      <mat-icon color="primary" mat-list-icon>developer_board</mat-icon>
      <mat-label>{{ 'MENU.developer' | translate }}</mat-label>
    </a>
    <button (click)="copyProjectId()" *isDev mat-menu-item>
      <mat-icon color="primary">content_copy</mat-icon>
      <mat-label>{{ 'MENU.copy_project_id' | translate }}</mat-label>
    </button>
    <button (click)="copyUserId()" *isDev mat-menu-item>
      <mat-icon color="primary">person_pin_circle</mat-icon>
      <mat-label>{{ 'MENU.copy_user_id' | translate }}</mat-label>
    </button>
    <button (click)="logout()" mat-menu-item>
      <mat-icon color="primary" mat-list-icon>exit_to_app</mat-icon>
      <mat-label>{{ 'MENU.exit' | translate }}</mat-label>
    </button>
  </ng-template>
</mat-menu>
